<template>
  <div>
    <Modal
        :title="title"
        :value="value"
        class-name="uploadModal"
        @on-visible-change="visibleChange"
        @on-ok="confirm"
        @on-cancel="$emit('cancel')">
        <Form :model="current" label-position="left" :label-width="50">
          <FormItem label="标题">
            <Input v-model="current.title" style="width:300px"></Input>
          </FormItem>
          <FormItem label="图标">
            <Input v-model="current.iconName" style="width:300px" readonly></Input>
            <Upload ref="upload" :data="uploadFileInit.extradata" :action="uploadFileInit.action" :before-upload="handleBeforeUpload" :show-upload-list="false">
              <Button type="primary" size="small">图标上传</Button>
            </Upload>
          </FormItem>
          <FormItem label="链接">
            <Input v-model="current.reportSysUrl" style="width:300px"></Input>
          </FormItem>
          <!-- <FormItem label="排序">
            <Input v-model="current.rank" style="width:300px"></Input>
          </FormItem> -->
        </Form>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import requestUrls from '@/lib/requestUrls'
import { fileUtil } from '@/lib/abpfile'
import Util from '@/lib/util'

export default {
  props: {
    title: String,
    current: Object,
    value: Boolean
  },
  data() {
    return {
      uploadFileInit: {
        action: "",
        extradata: {}
      },
      userId: Util.abp.session.userId,
      fileType: 1,
      bucket: "chinapsp-resource",
      dir: "icon/",
      file: {}
    }
  },
  methods: {
    visibleChange(value){
      if(!value){
        this.$emit('input',value);
      }
    },
    handleBeforeUpload(file) {
      // 初始化文件上传
      fileUtil.downloadInit(this.userId,this.fileType,this.bucket,this.dir).then(val => {
        this.uploadFileInit = val
      })
      this.file = file
      this.$emit('file', file.name)
      return false
    },
    async fileUpload() {
      let suffix = fileUtil.get_suffix(this.file.name)
      this.uploadFileInit.extradata.key = this.uploadFileInit.extradata.key + fileUtil.random_string(10) + suffix
      this.uploadFileInit.extradata['x:displayname'] = this.file.name
      this.uploadFileInit.extradata['x:objectid'] = this.current.id
      this.uploadFileInit.extradata['x:objectidtype'] = 'icon'
      this.current.iconUrl = await this.uploadFileInit.extradata.key
      this.$Spin.show()
      try {
        let uploadData = new FormData()
        for (let key in this.uploadFileInit.extradata) {
          uploadData.append(key, this.uploadFileInit.extradata[key])
        }
        uploadData.append('file', this.file)
        let rep = await axios.post(this.uploadFileInit.action, uploadData)
        this.$Spin.hide()
        if (rep.data.success) {
          this.$emit('ok', this.current)
          this.file = {}
        } else {
          this.$Message.error(`${this.file.name}上传失败`)
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error(`${this.file.name}上传失败`)
      }
      return
    },
    confirm() {
      if(!this.file.name) {
        this.$emit('ok', this.current)
      } else {
        this.fileUpload()
      }
    }
  }
};
</script>

<style lang="less">
.uploadModal .ivu-upload {
  display: inline;
  margin-left: 8px;
}
.ivu-table-cell img {
  width: 30px;
  vertical-align: middle;
}
</style>
